import InfoIcon from "Assets/Icons/InfoIcon";
import NotMarkedNew from "Assets/Icons/NotMarkedIconNew";
import NotMarkedMB from "Assets/Icons/NotMarkedMB";
import NotMarkedMBWhite from "Assets/Icons/NotMarkedMBWhite";
import NotMarkedNewWhite from "Assets/Icons/NotMarkedNewWhite";
// import RightArrow from "Assets/Icons/RightArrow";
import RightArrowWhiteIcon from "Assets/Icons/RightArrowWhiteIcon";
import TickIcon from "Assets/Icons/TickIcon";
import TickIconMB from "Assets/Icons/TickIconMB";
import TickIconWhite from "Assets/Icons/TickIconWhite";
import TickIconWhiteMB from "Assets/Icons/TickIconWhiteMB";
import SingleSelectHookForm from "Components/CommonComponents/SingleSelectHookForm";
import { LectureStyledSpan1 } from "Pages/MyBatches/MyBatch/MyBatchTabs/MyBatchSyllabusTab";
import { LoginFormFields } from "Pages/UserManagement/UserManagementForm";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
// import UnMarkedIcon from "Assets/Icons/UnmarkedIcon";
import { Card, Tooltip } from "reactstrap";
import styled from "styled-components";
const ListingDiv = styled<any>("div")`
  display: flex;
  justify-content: space-between;
  padding: 16px 12px;
  cursor: pointer;
  background: ${({ isSelected }: any) => (isSelected ? "#008DC4" : "#ffffff")};
  color: ${({ isSelected }: any) => (isSelected ? "#fff" : "#333")};
`;
const ScheduledDiv1Card = styled<any>(Card)`
  height: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "calc(100% - 162px)" : "100%"};
  overflow: auto;
  border: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen)
      ? "0px"
      : "1px solid #AFAFAF !important"};
  background: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "#FCFCFC" : ""};
`;
const StyledSpan = styled<any>("span")`
  font-size: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "12px" : ""};
  font-weight: 700;
  margin-top: 2px;
`;
const PlannedLectureListingCard = ({
  planneLecturedList,
  selectedPlannedLecture,
  setSelectedPlannedLecture,
  selectedType,
  plannedLecture,
  handleSelectedChapter,
  onSelectedChange,
  screen,
  mode,
  fullTOCRes,
}: any) => {
  const {
    register,
    control,
    formState: { errors },
  } = useForm<LoginFormFields>();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const selectedListingRef: any = useRef(null);
  useEffect(() => {
    if (
      ["myScheduleHome"].includes(mode) &&
      !["xs", "sm", "md"].includes(screen) &&
      selectedListingRef.current
    ) {
      selectedListingRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [selectedPlannedLecture]);
  const returnComplete = (arr: any) => {
    return arr.filter((ele: any) => ele.marked === 3)?.length;
  };
  return (
    <ScheduledDiv1Card screen={screen} mode={mode}>
      {!["xs", "sm", "md"].includes(screen) && (
        <div className={"p-2 d-flex justify-content-between w-100"}>
          <div>
            <SingleSelectHookForm
              disabled={false}
              error={errors}
              controlName={control}
              placeholder="Select role"
              width={["xs", "sm", "md"].includes(screen) ? "100%" : "160px"}
              isInPerformance={false}
              options={[
                {
                  label: "Chapter",
                  value: "chapter",
                },
                {
                  label: "Planned Lectures",
                  value: "plannedLectures",
                },
              ]}
              menuPlacement="bottom"
              isClearable={false}
              isSearchable={true}
              isSearchableDrop={true}
              isDropdownSelect={true}
              top={"0px"}
              menuShouldScrollIntoView={true}
              closeMenuOnSelect={true}
              hideSelectedOptions={false}
              isBorder={false}
              name={"fexRole"}
              register={register}
              rules={{
                required: "You must select user role.",
              }}
              onChange={(selected: any) => {
                onSelectedChange(selected);
              }}
              defaultValue={[selectedType]}
            />
          </div>
          {!["xs", "sm", "md"].includes(screen) && (
            <div className="d-flex align-items-center">
              {selectedType.value === "plannedLectures" ? (
                <>
                  <LectureStyledSpan1>
                    {plannedLecture?.totalMarked}/
                    {plannedLecture?.totalPlannedLecture}
                  </LectureStyledSpan1>
                  <span>
                    <InfoIcon id={"Tooltip-attendance"}></InfoIcon>
                    <Tooltip
                      placement={"top"}
                      isOpen={tooltipOpen}
                      target={"Tooltip-attendance"}
                      toggle={toggle}
                    >
                      {
                        "Number of planned lectures (PL) completed out of the total planned lectures"
                      }
                    </Tooltip>
                  </span>
                </>
              ) : (
                <>
                  <LectureStyledSpan1>
                    <>
                      {fullTOCRes?.completedChapters != null
                        ? returnComplete(fullTOCRes?.completedChapters)
                        : 0}
                    </>
                    /{fullTOCRes?.courseToc?.length}
                  </LectureStyledSpan1>

                  <span>
                    <InfoIcon id={"Tooltip-attendance"}></InfoIcon>
                    <Tooltip
                      placement={"top"}
                      isOpen={tooltipOpen}
                      target={"Tooltip-attendance"}
                      toggle={toggle}
                    >
                      {"Number of chapters completed out of the total chapters"}
                    </Tooltip>
                  </span>
                </>
              )}
            </div>
          )}
        </div>
      )}
      <div className="listingDiv">
        {planneLecturedList.map((ele: any, index: number) => {
          return (
            <ListingDiv
              ref={
                ele.id === selectedPlannedLecture?.id
                  ? selectedListingRef
                  : null
              }
              key={index}
              isSelected={selectedPlannedLecture?.id == ele.id}
              onClick={() => {
                if (selectedType.value == "chapter") {
                  handleSelectedChapter(ele);
                } else {
                  setSelectedPlannedLecture(ele);
                }
              }}
            >
              <div className="d-flex align-items-center">
                <StyledSpan screen={screen}>
                  {" "}
                  {selectedType.value == "plannedLectures" ? (
                    <>
                      {["xs", "sm", "md"].includes(screen)
                        ? "PL"
                        : "Planned Lecture"}
                    </>
                  ) : (
                    <>
                      {String(ele.id).includes("revision")
                        ? ["xs", "sm", "md"].includes(screen)
                          ? "RV"
                          : "Revision"
                        : ["xs", "sm", "md"].includes(screen)
                        ? "Ch"
                        : "Chapter"}
                    </>
                  )}{" "}
                  {String(ele.id).includes("revision") ? "" : index + 1}
                </StyledSpan>
                {selectedPlannedLecture?.id != ele.id ? (
                  <span
                    className={
                      ["xs", "sm", "md"].includes(screen) ? "pl-1" : "pl-2"
                    }
                  >
                    {ele.isComplete == 3 ? (
                      <>
                        {["xxl", "xl", "lg"].includes(screen) ? (
                          <TickIcon />
                        ) : (
                          <TickIconMB></TickIconMB>
                        )}
                      </>
                    ) : ele.isComplete == 2 ? (
                      <>
                        {["xxl", "xl", "lg"].includes(screen) ? (
                          <NotMarkedNew></NotMarkedNew>
                        ) : (
                          <NotMarkedMB></NotMarkedMB>
                        )}
                      </>
                    ) : null}
                  </span>
                ) : (
                  <span
                    className={
                      ["xs", "sm", "md"].includes(screen) ? "pl-1" : "pl-2"
                    }
                  >
                    {ele.isComplete == 3 ? (
                      <>
                        {["xxl", "xl", "lg"].includes(screen) ? (
                          <TickIconWhite />
                        ) : (
                          <TickIconWhiteMB></TickIconWhiteMB>
                        )}
                      </>
                    ) : ele.isComplete == 2 ? (
                      <>
                        {["xxl", "xl", "lg"].includes(screen) ? (
                          <NotMarkedNewWhite></NotMarkedNewWhite>
                        ) : (
                          <NotMarkedMBWhite></NotMarkedMBWhite>
                        )}
                      </>
                    ) : null}
                  </span>
                )}
              </div>
              <div className="d-flex align-items-center">
                {ele.id != selectedPlannedLecture?.id ? (
                  <></>
                ) : (
                  <RightArrowWhiteIcon></RightArrowWhiteIcon>
                )}
              </div>
            </ListingDiv>
          );
        })}
      </div>
    </ScheduledDiv1Card>
  );
};
export default PlannedLectureListingCard;
